<template>
    <div style="display: flex; flex-direction: column; background-color: #fff;">
        <div style="margin-top: 31px; position: relative; display: flex; margin-bottom: 16px; align-items: center; justify-content: space-between; padding: 0 12px;">
            <div style="display:flex; align-items: center; " @click="beforeCloseAction">
                <img :src="require('@/assets/img/ico-move_black.png')" style="width: 10px;">
                <span style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">뒤로가기</span>
            </div>
            <div style="padding: 8px 16px; position: absolute; left: 50%; transform: translateX(-50%); display: inline-block; font-size: 14px; line-height: 20px; font-weight: 700; border-radius: 20px; background: #210F03E5; text-align: center; color: #fff;">
                {{ soccerhow.visit_cnt }}명이 조회
            </div>
            <div @click="setIsShowPopMenu" style="display: flex; flex-direction: column; gap: 3px;">
                <div style="width: 5px; height: 5px; background-color: #210f03; border-radius: 50%;"></div>
                <div style="width: 5px; height: 5px; background-color: #210f03; border-radius: 50%;"></div>
                <div style="width: 5px; height: 5px; background-color: #210f03; border-radius: 50%;"></div>
            </div>
        </div>
        <InfinityScroll :refresh-action="refreshDetail" style="flex: 1; overflow: hidden;">
            <div style="height: 100%; padding: 0 12px; overflow-y: scroll;">
                <div style="margin-top: 20px; display: flex; flex-direction: column; align-items: center;" @click="$Util.showProfile(soccerhow.writer_idx, soccerhow.writer_type)">
                    <ProfileImage :imagePath="soccerhow.image_path" style="width: 60px;"></ProfileImage>
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px; margin-top: 8px;">
                        {{ soccerhow.nic_name }}
                        <DivisionPositionText v-if="false" :position="soccerhow.position" :positionProAbility="memberInfo.position_pro_ability"></DivisionPositionText>
                    </div>
                    <div style="display: flex; align-items: center; color: #606060; gap: 4px; font-weight: 500; font-size: 12px; line-height: 16px;">
                        {{ soccerhow.place_name }}
                        <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #210F03B2;"></span>
                        {{ soccerhow.insert_date | agoDateStr }}
                    </div>
                </div>
                <div v-if="Object.keys(soccerhow).length > 0" style="margin-top: 20px; background: #f5f5f5; padding: 12px; border-radius: 12px;">
                    <CommonPost :hideOption="true" :isDetail="true" :isFeed="main_type === MAIN_TYPE.SOCCER_LEARN ? true : false" :soccerHows="soccerhow"></CommonPost>
                </div>
                <div v-if="isMeCreator && main_type === MAIN_TYPE.SOCCER_TEAM_JOINING && isReportingExist" @click="showMyReport(); $Util.sendEventClick('사커하우_요청서리포트_자세히보기')" style="margin: 20px 0; display: flex; justify-content: center; gap: 4px; align-items: center;">
                    <img style="width: 20px;" :src="require('@/assets/img/show_report.png')" alt="">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px; color: var(--color-main);">요청서 리포트 보기</div>
                    <img style="width: 10px;" :src="require('@/assets/img/arrow_main_color.png')" alt="">
                </div>
                <div ref="test" style="margin-top: 20px;">
                    <div style="display: flex; gap: 12px; justify-content: center;">
                        <InteractionOfBtnBackgroundColor v-if="isMeCreator" style="border-radius: 20px;" originColor="#210F031A" completeColor="#FF711180" changeColor="#D9D9D9" :curType="curType" :btnType="BTN_TYPE.REQUEST">
                            <div @click="setBtnType(BTN_TYPE.REQUEST)" style="padding: 12px 20px; line-height: 16px; font-size: 14px; text-align: center; font-weight: 700; border-radius: 20px;">요청 {{ directMessage.length }}</div>
                        </InteractionOfBtnBackgroundColor>
                        <InteractionOfBtnBackgroundColor style="border-radius: 20px;" originColor="#210F031A" completeColor="#FF711180" changeColor="#D9D9D9" :curType="curType" :btnType="BTN_TYPE.ALARM">
                            <div @click="setBtnType(BTN_TYPE.ALARM)" style="padding: 12px 20px; line-height: 16px; font-size: 14px; text-align: center; font-weight: 700; border-radius: 20px;">알림 {{ pushMessage.length }}</div>
                        </InteractionOfBtnBackgroundColor>
                        <InteractionOfBtnBackgroundColor v-if="main_type === MAIN_TYPE.SOCCER_LEARN" style="border-radius: 20px;" originColor="#210F031A" completeColor="#FF711180" changeColor="#D9D9D9" :curType="curType" :btnType="BTN_TYPE.REPLY">
                            <div @click="setBtnType(BTN_TYPE.REPLY)" style="padding: 12px 20px; line-height: 16px; font-size: 14px; text-align: center; font-weight: 700; border-radius: 20px;">피드백 및 댓글</div>
                        </InteractionOfBtnBackgroundColor>
                    </div>
                </div>
                <div style="margin-top: 20px;">
                    <template v-if="isMeCreator && curType === BTN_TYPE.REQUEST">
                        <div v-for="each, i in directMessage" :key="i + 'directMessage'" style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); border-radius: 12px; height: 304px; padding: 20px 12px; margin-bottom: 20px;">
                            <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                                <div>
                                    <ProfileImage :imagePath="each.from_member.image_path" style="width: 80px;"></ProfileImage>
                                </div>
                                <div style="display: flex; align-items: center; gap: 4px;">
                                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">{{ each.from_member.nic_name }}</div>
                                    <img style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                </div>
                            </div>
                            <div style="font-size: 15px; font-weight: 500; line-height: 24px; padding: 8px 12px; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); margin-top: 12px; border-radius: 12px;">
                                <span style="font-weight: 700;">{{ each.contents }}</span>
                                <div style="font-weight: 500; font-size: 12px; margin-top: 4px; line-height: 24px; color: #606060; text-align: right;">{{ each.update_date | agoDateStr }}</div>
                            </div>
                            <div style="display: flex; gap: 12px; margin-top: 12px; justify-content: center;">
                                <div @click="setModal(MODAL_TYPE.REJECT, i, each); $Util.sendEventClick('사커하우_요청서_거절하기')" style="padding: 12px 20px; border-radius: 20px; background-color: #210F031A; font-weight: 700; font-size: 14px; line-height: 16px;">거절하기</div>
                                <div @click="setModal(MODAL_TYPE.ACCEPT, i, each); $Util.sendEventClick('사커하우_요청서_수락하기')" style="padding: 12px 20px; border-radius: 20px; background-color: var(--color-main); font-weight: 700; font-size: 14px; line-height: 16px;">메시지 수락</div>
                            </div>
                        </div>
                    </template>
                    <template v-if="curType === BTN_TYPE.ALARM">
                        <div v-for="each, i in pushMessage" :key="i + 'pushMessage'" style="display: flex; gap: 12px; margin-bottom: 20px;">
                            <div @click.stop="$Util.showProfile(each.req_member.idx)" style="margin-top: 12px;">
                                <ProfileImage :imagePath="each.req_member.image_path" style="width: 40px; height: 40px;"></ProfileImage>
                            </div>
                            <div>
                                <div style="display: flex; align-items: center; gap: 4px;">
                                    <div style="font-weight: 700; font-size: 12px; line-height: 24px;">{{ each.req_member.nic_name }}</div>
                                    <img v-if="each.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                    <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                </div>
                                <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 8px 12px; display: inline-block; border-radius: 12px;">
                                    <div style="line-height: 24px; font-weight: 500; font-size: 15px;">{{ each.message }}</div>
                                </div>
                                <div style="font-size: 11px; font-weight: 500; color: #606060; line-height: 24px;">{{ each.push_date | agoDateStr }}</div>
                            </div>
                        </div>
                    </template>
                    <template v-if="curType === BTN_TYPE.REPLY">
                        <div :style="{ marginBottom: $GlobalStore.loginInfo().is_coach == 1 ? '50px' : '0' }" style="margin-bottom: 50px;">
                            <div style="font-weight: 700; line-height: 24px; margin-bottom: 10px;">전문가 피드백 <span style="color: var(--color-main);">{{ feedbackList.length }}</span></div>
                            <swiper v-if="feedbackList.length > 0" style="margin: 0 -12px; padding: 0 12px;" :options="swiperOption">
                                <swiper-slide style="" v-for="each, i in feedbackList" :key="i + 'expertFeedback'">
                                    <ExpertFeedbackWrapper :completeAction="getFeedbackList" :setLikeState="setLikeState" :index="i" :feedbackInfo="each"></ExpertFeedbackWrapper>
                                </swiper-slide>
                                <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; top: 14px; height: 20px; text-align: right; padding-right: 20px; z-index: 10; display:inline-block;"></div>
                            </swiper>
                            <div style="margin-top: 20px; display: flex; flex-direction: column; align-items: center; margin-bottom: 22px;" v-else>
                                <div style="width: 47px; height: 47px; border-radius: 50%; background-color: #ebebeb; display: flex; align-items: center; justify-content: center; gap: 6px;">
                                    <div style="width: 8px; height: 8px; background-color: #fff; border-radius: 50%;"></div>
                                    <div style="width: 8px; height: 8px; background-color: #fff; border-radius: 50%;"></div>
                                    <div style="width: 8px; height: 8px; background-color: #fff; border-radius: 50%;"></div>
                                </div>
                                <div style="margin-top: 20px; font-weight: 700; line-height: 24px;">아직 전문가의 피드백이 없어요</div>
                            </div>
                            <div v-if="$GlobalStore.loginInfo().is_coach == 1" @click="writeFeedback" class="feedback_write_btn">피드백 작성하기</div>
                        </div>
                        <div :style="{ marginBottom: replies.length > 0 ? '0' : '20px' }" style="font-weight: 700; line-height: 24px;">댓글 <span style="color: var(--color-main);">{{ replies.length }}</span></div>
                        <div v-if="replies.length === 0" style="margin-top: 20px; display: flex; flex-direction: column; align-items: center; margin-bottom: 22px;">
                            <div style="width: 47px; height: 47px; border-radius: 50%; background-color: #ebebeb; display: flex; align-items: center; justify-content: center; gap: 6px;">
                                <div style="width: 8px; height: 8px; background-color: #fff; border-radius: 50%;"></div>
                                <div style="width: 8px; height: 8px; background-color: #fff; border-radius: 50%;"></div>
                                <div style="width: 8px; height: 8px; background-color: #fff; border-radius: 50%;"></div>
                            </div>
                            <div style="margin-top: 20px; font-weight: 700; line-height: 24px;">아직 댓글이 없어요</div>
                        </div>
                        <CommonReply
                            :completeAction="getReplyList" 
                            :replies="replies" 
                            :curCommentReplyIdx="cur_reply_soccerhow_idx" 
                            :setReplyIdx="setReplyIdx" 
                            :soccerhowIdx="soccerhowIdx"
                            :isChangeBackground="true"
                        ></CommonReply>
                    </template>
                </div>
            </div>
        </InfinityScroll>
        <div v-if="isExpert && curType !== BTN_TYPE.REPLY && !isMeCreator && is_loaded" style="height: 108px;">
            <div style="display: flex; gap: 9px; margin-top: 8px; padding: 0 12px;">
                <InteractionOfScale style="flex: 1;" v-if="is_me_member_liked">
                    <div @click="cancelMemberLike(); $Util.sendEventClick('사커하우_요청서_관심선수취소', true)" style="display: flex; justify-content: center; align-items: center; gap: 4px; height: 60px; border-radius: 50px; font-size: 14px; font-weight: 700; background: linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%);">
                        <img style="width: 16px" :src="require('@/assets/img/star_gold.png')" alt="">
                        <div>관심</div>
                    </div>
                </InteractionOfScale>
                <InteractionOfScale style="flex: 1;" v-else>
                    <div @click="sendLike(); $Util.sendEventClick('사커하우_요청서_관심선수등록', true)" style="display: flex; justify-content: center; align-items: center; gap: 4px; height: 60px; border-radius: 50px; font-size: 14px; font-weight: 700; background: linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%);">
                        <img style="width: 16px" :src="require('@/assets/img/star_black.png')" alt="">
                        <div>관심</div>
                    </div>
                </InteractionOfScale>
                <InteractionOfScale style="flex: 1;">
                    <div @click="showDirectMessage(); $Util.sendEventClick('사커하우_요청서_다이렉트메시지', true)" style="height: 60px; gap: 4px; display: flex; justify-content: center; align-items: center; border-radius: 50px; font-size: 14px; font-weight: 700; background-color: #210f03; color: var(--color-main);">
                        <img style="width: 16px" :src="require('@/assets/img/dm_main_color.png')" alt="">
                        <div>스카우트 제의</div>
                    </div>
                </InteractionOfScale>
            </div>
        </div>
        <template v-else-if="curType === BTN_TYPE.REPLY">
            <div style=" display:flex; width:100%; padding:8px 12px; align-items: flex-end; background-color: white; border-top:1px solid #F5F5F5;">
                <div style="flex:1; position: relative; display: flex; gap: 8px;">
                    <ProfileImage :imagePath="myImagePath" style="width: 40px; height: 40px"></ProfileImage>
                    <div style="display:flex; flex:1; background-color: #efefef; border-radius:25px; align-items: center;; background-color: #efefef;  border-radius:20px; ">
                        <div v-if="cur_reply_soccerhow_idx !== -1" style="font-size:14px; color:var(--color-main); padding-left: 12px;">@{{ inputNicName }}</div>
                        <textarea rows="1" ref="chatInput" style="background-color:transparent; flex:1; width: 100%; max-height: 350px; resize:none; outline: none; border:0px; padding: 10px 15px; padding-right: 40px; font-size:14px; line-height:20px; overflow:hidden; overflow-y: scroll;" placeholder="댓글 달기" v-model="replyContents" oninput='this.style.height = ""; this.style.height = (this.scrollHeight) + "px"' @focus="checkLogin" @input="calcContentsLength($event)" @blur="backToMainReply"></textarea>
                    </div>
                    <div @click="submit">
                        <div v-if="contentsLength === 0" style="width: 32px; height: 32px; display: flex; justify-content: center; align-items: center; position: absolute; right: 12px; top: 50%; transform: translateY(-50%); background-color: #D9D9D9; border-radius: 50%;">
                            <img :src="require('@/assets/img/chat_send_white.png')" style="width:12px; height:16px;">
                        </div>
                        <div @click="submitReply" v-else style="width: 32px; background-color: #210f03; display: flex; align-items: center; justify-content: center; height: 32px; border-radius: 50%; display: flex; justify-content: center; position: absolute; right: 12px; top: 50%; transform: translateY(-50%);">
                            <img :src="require('@/assets/img/chat_send_white.png')" style="width:12px; height:16px;">
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <ModalFrameBasic :isOpen="isShowPossessionDm" :height="'580px'">
            <div style="display: flex; height: 100%; flex-direction: column;">
                <div @click="closePossessionDm" style="font-weight: 700;">닫기</div>
                <div style="display: flex; flex: 1; flex-direction: column; align-items: center; margin-top: 46px;">
                    <div>다이렉트 메시지 보유</div>
                    <div style="height: 169px; width: 225px; background-color: #d9d9d9; margin-top: 30px;">
                        몇 개
                    </div>
                    <div style="height: 72px; width: 100%; background-color: #d9d9d9; margin-top: 30px;">
                        충전 배너
                    </div>
                </div>
                <div @click="showDirectMessage" style="width: 300px; height: 56px; border-radius: 50px; background-color: var(--color-main); text-align: center; line-height: 56px; font-size: 14px; font-weight: 700;">사용하기</div>
            </div>
        </ModalFrameBasic>
        <BookmarkPopup :isShowBookmarkPopup="isShowBookmarkPopup" :closeBookmarkPopup="closeBookmarkPopup">
            <div>
                <div @click="closeBookmarkPopup" style="font-weight: 700;">닫기</div>
                <div style="margin-top: 24px; text-align: center;">
                    <ProfileImage style="width: 100px;" :image-path="$resourcePath + soccerhow.image_path" />
                </div>
                <div style="margin-top: 20px; font-size: 20px; line-height: 24px; font-weight: 700; text-align: center;">관심있는 선수로 등록했습니다.</div>
                <div @click="closeBookmarkPopup" style="width: 186px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">확인</div>
            </div>
        </BookmarkPopup>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
        <MakeRequestJoinForm :soccerhowIdx="soccerhowIdx" :mode="'update'" :isLearn="main_type === MAIN_TYPE.SOCCER_LEARN ? true : false" :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="closeRequestJoinForm"></MakeRequestJoinForm>
        <CommonPopupFrame :changeBottom="0" :changeHeight="modalHeight" :changeHeightUnit="'px'" :isOpen="isShowModal" :closeCompleteAction="closeModal">
            <div v-if="curModalType === MODAL_TYPE.ACCEPT" style="padding: 16px 20px;">
                <div @click="closeModal" style="font-weight: 700;">닫기</div>
                <div style="text-align: center; margin-top: 12px;">
                    <div v-if="!isExpert" style="font-weight: 700; font-size: 20px; line-height: 33px;">다이렉트 메시지를 수락하고<br>감독님과의 채팅을 오픈할까요?</div>
                    <div v-else style="font-weight: 700; font-size: 20px; line-height: 24px;">다이렉트 요청서를 수락하고<br>선수와의 채팅을 오픈할까요?</div>
                    <div v-if="!isExpert" style="display: flex; gap: 10px; font-weight: 500; color: #606060; justify-content: center; margin-top: 20px;">
                        <span style="display: inline-block; margin-top: 10px; width: 5px; height: 5px; border-radius: 50%; background: #808080;"></span>
                        <div style=" line-height: 24px;">원활한 상담 및 소통을 위해 메시지를 보낸 곳<br>이 <span style="font-weight: 700; color: #210F03;">어떤 팀</span>인지 다시 한번 확인해주세요.</div>
                    </div>
                    <div v-else style="display: flex; gap: 10px; font-weight: 500; color: #606060; justify-content: center; margin-top: 20px;">
                        <span style="display: inline-block; margin-top: 10px; width: 5px; height: 5px; border-radius: 50%; background: #808080;"></span>
                        <div style=" line-height: 24px;">원활한 상담 및 소통을 위해 메시지를 보낸 사<br>람이 <span style="font-weight: 700; color: #210F03;">어떤 선수</span>인지 다시 한번 확인해주세요.</div>
                    </div>
                </div>
                <div @click="openChatting" style="border-radius: 40px; margin: 0 auto; margin-top: 40px; width: 237px; height: 56px; line-height: 56px; background-color: #210f03; text-align: center; font-size: 14px; color: var(--color-main); font-weight: 700;">채팅 오픈하기</div>
            </div>
            <div style="padding: 16px 20px;" v-else-if="curModalType === MODAL_TYPE.REJECT">
                <div @click="closeModal" style="font-weight: 700;">닫기</div>
                <div v-if="!isExpert" style="margin-top: 32px; font-size: 20px; font-weight: 700; text-align: center;">다이렉트 메시지를 거절할까요?</div>
                <div v-else style="margin-top: 32px; font-size: 20px; font-weight: 700; text-align: center;">다이렉트 요청서를 거절할까요?</div>
                <div @click="confirmRejectDirectMessage" style="border-radius: 40px; margin: 0 auto; margin-top: 40px; width: 186px; height: 56px; line-height: 56px; background-color: #210f03; text-align: center; font-size: 14px; color: var(--color-main); font-weight: 700;">확인</div>
            </div>
            <div v-else-if="curModalType === MODAL_TYPE.JOIN" style="padding: 16px 20px;">
                <div @click="closeModal" style="font-weight: 700;">닫기</div>
                <div style="margin-top: 32px; font-size: 20px; font-weight: 700; text-align: center;">멤버톡에 참여할까요?</div>
                <div @click="joinMemberTalk" style="border-radius: 40px; margin: 0 auto; margin-top: 40px; width: 186px; height: 56px; line-height: 56px; background-color: #210f03; text-align: center; font-size: 14px; color: var(--color-main); font-weight: 700;">참여하기</div>
            </div>
        </CommonPopupFrame>
        <BookmarkPopup :height="473" :isShowBookmarkPopup="isShowBookmarkPopupMessage" :closeBookmarkPopup="closeBookmarkPopup">
            <div style="display: flex; flex-direction: column; height: 100%;">
                <div>
                    <div @click="closeBookmarkPopup" style="font-weight: 700;">닫기</div>
                </div>
                <div style="flex: 1; position: relative;">
                    <div style="display: flex; margin-top: 53px; padding: 0 32px; align-items: center; justify-content: space-between;">
                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <ProfileImage :image-path="coach_member.image_path" style="width: 100px;"></ProfileImage>
                            <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;">
                                <div style="font-weight: 700; font-size: 12px; line-height: 16px;">{{ coach_member.nic_name }}</div>
                                <div>
                                    <img style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                </div>
                            </div>
                        </div>
                        <div style="display: flex; gap: 4px;">
                            <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                            <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                            <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                            <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                            <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                        </div>
                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <ProfileImage :image-path="user_member.image_path" style="width: 100px;"></ProfileImage>
                            <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;">
                                <div style="font-weight: 700; font-size: 12px; line-height: 16px;">{{ user_member.nic_name }}</div>
                                <div style="font-size: 11px; font-weight: 900; color: var(--color-main);">{{ user_member.position }}</div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 40px; text-align: center;">
                        <div style="font-weight: 700; font-size: 20px; line-height: 32px;">채팅을 오픈했습니다👏<br>입단 테스트 일정을 잡으세요!</div>
                    </div>
                    <div @click="showPesonalChat" style="border-radius: 40px; margin: 0 auto; margin-top: 40px; width: 237px; height: 56px; line-height: 56px; background-color: #210f03; text-align: center; font-size: 14px; color: var(--color-main); font-weight: 700;">대화 시작하기</div>
                </div>
            </div>
        </BookmarkPopup>
        <BookmarkPopup :background="'#fff'" :height="280" :isShowBookmarkPopup="isShowBookmarkPopupReport" :closeBookmarkPopup="closeBookmarkPopup">
            <div>
                <div @click="closeBookmarkPopup" style="font-weight: 700;">닫기</div>
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 24px; margin-top: 12px;">게시물을 신고할까요?</div>
                    <div style="margin-top: 20px; color: #606060; font-weight: 500; line-height: 24px;">좋지 않은 게시물을 신고할 수 있습니다.<br>신고를 진행할까요?</div>
                    <div @click="report" style="width: 210px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">신고하기</div>
                </div>
            </div>
        </BookmarkPopup>
        <BookmarkPopup :height="228" :isShowBookmarkPopup="isShowBeforeClosePopup" :closeBookmarkPopup="closeBeforeClosePopup">
            <div>
                <div @click="closeBeforeClosePopup" style="font-weight: 700;">닫기</div>
                <div style="text-align: center;">
                    <div v-html="popupTitle" style="font-weight: 700; font-size: 20px; line-height: 24px; margin-top: 24px;"></div>
                    <div @click="beforeClosePopupFunc" style="width: 236px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 20px;">{{ btnName }}</div>
                </div>
            </div>
        </BookmarkPopup>
    </div>
</template>

<script>
const BTN_TYPE = {
    REQUEST: '요청',
    ALARM: '알림',
    REPLY: '댓글'
}

import { MAIN_TYPE, SOCCER_HOW_TYPE, REPORT_TYPE_IDX, TEAM_TYPE, MISSION_TYPE, FEEDBACK_MODE } from '@/Constants'
import ProfileImage from '@/components/common/ProfileImage'
import MakeRequestJoinForm from '@/components/soccerhowmain/MakeRequestJoinForm';
import CommonPost from '@/components/soccerhowmain/CommonPost'
import ModalFrameBasic from '@/components/common/ModalFrameBasic'
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup'
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import ResponseCode from '@/ResponseCode'
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import InfinityScroll from '@/components/common/InfinityScroll'
import CommonReply from '@/components/common/CommonReply'
import InteractionOfScale from '@/components/common/InteractionOfScale';
import InteractionOfBtnBackgroundColor from '@/components/common/InteractionOfBtnBackgroundColor';
import DivisionPositionText from '@/components/common/DivisionPositionText'
import moment from 'moment'
import ExpertFeedbackWrapper from '@/components/common/ExpertFeedbackWrapper'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

const MODAL_TYPE = {
    ACCEPT: '메시지수락',
    REJECT: '메시지거절',
}

export default {
    name: 'TrainingRequestDetail',
    components: { ProfileImage, CommonPost, ExpertFeedbackWrapper, DivisionPositionText, InteractionOfBtnBackgroundColor, InteractionOfScale, CommonReply, CommonPopupFrame, MakeRequestJoinForm, ModalFrameBasic, BookmarkPopup, BottomPopupMenu, InfinityScroll, swiper, swiperSlide },
    props: {
        main_type: {
            type: String,
            default: MAIN_TYPE.SOCCER_TEAM_JOINING,
        },
        isExpert: {
            type: Boolean,
            default: false
        },
        soccerhowIdx: {
            type: [Number, String],
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        isFromChatRuqest: {
            type: Boolean,
            default: false
        },
        refresh: {
            type: Function,
            default: () => { }
        },
        isPopular: {
            type: Boolean,
            default: false
        },
        isRealTime: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            FEEDBACK_MODE: FEEDBACK_MODE,
            swiperOption: {
                // slidesPerView: 'auto',
                spaceBetween: 12, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                curIndex: 0,
            },
            MISSION_TYPE: MISSION_TYPE,
            isShowBeforeClosePopup: false,
            TEAM_TYPE: TEAM_TYPE,
            modalHeight: 0,
            MAIN_TYPE: MAIN_TYPE,
            BTN_TYPE: BTN_TYPE,
            curType: BTN_TYPE.REQUEST,
            isShowPossessionDm: false,
            isShowBookmarkPopup: false,
            cur_reply_soccerhow_idx: -1,
            inputNicName: null,
            contentsLength: 0,
            contents: '',
            isShowPopMenu: false,
            menuOptions: {},
            directMessage: [],
            pushMessage: [],
            isReportingExist: false,
            isShowMakeRequestJoinForm: false,
            replies: [],
            soccerhow: {},
            memberInfo: {},
            replyContents: '',
            curModalType: MODAL_TYPE.ACCEPT,
            isShowModal: false,
            MODAL_TYPE: MODAL_TYPE,
            selectMessage: {},
            coach_member: {},
            user_member: {},
            chatIdx: -1,
            isShowBookmarkPopupMessage: false,
            is_me_member_liked: false,
            is_loaded: false,
            isShowBookmarkPopupReport: false,
            cur_modal_length: -1,
            isActiveCommentReply: false,
            popupTitle: '',
            beforeClosePopupFunc: () => {},
            btnName: '',
            curFeedbackMode: FEEDBACK_MODE.VIEW,
            feedbackList: []
        };
    },
    beforeDestroy() {
        window.visualViewport.removeEventListener('resize', this.detectResize);
    },
    mounted() {
        window.visualViewport.addEventListener("resize", this.detectResize);
    },
    created() {
        this.rejectOrAcceptDierectMessage = this.$Once(this.rejectOrAcceptDierectMessage)
        this.deleteSoccerhow = this.$Once(this.deleteSoccerhow)
        this.goToTop = this.$Once(this.goToTop)
        this.submitReply = this.$Once(this.submitReply)
        this.sendLike = this.$Once(this.sendLike)

        this.cur_modal_length = this.$GlobalStore.getModalLength();

        this.getSoccerhowDetail()
        this.getReplyList()
        this.getFeedbackList()
    },
    computed: {
        isMeCreator() {
            if (this.$GlobalStore.isLogin() && this.soccerhow.writer_idx === this.$GlobalStore.loginInfo().idx) {
                return true
            } else {
                return false
            }
        },
        isExpertConfirmed() {
            if (this.$GlobalStore.isLogin() && this.$GlobalStore.loginInfo().is_coach === '1') {
                return true
            } else {
                return false
            }
        },
        myImagePath() {
            return this.$GlobalStore.isLogin() ? this.$GlobalStore.loginInfo().image_path : null
        },
        isMeCoach() {
            if (this.$GlobalStore.isLogin() && this.$GlobalStore.loginInfo().is_temp_coach == 1) {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        setLikeState(likeTemp, likeNumber, index) {
            this.$set(this.feedbackList[index], 'like_yn', likeTemp);
            this.$set(this.feedbackList[index], 'like_number', likeNumber);
        },
        writeFeedback() {
            this.$GlobalStore.addModal('ExpertFeedbackModal', {
                feedbackInfo: this.feedbackInfo,
                transitionName: '',
                isModalBackTransparent: true,
                feedbackMode: FEEDBACK_MODE.WRITE,
                soccerhowIdx: this.soccerhowIdx,
                completeAction: this.getFeedbackList
            })
        },
        closeBeforeClosePopup() {
            this.isShowBeforeClosePopup = false
            this.beforeClosePopupFunc = () => {}
        },
        beforeCloseAction() {
            if (this.isMeCoach) {
                if (this.main_type === MAIN_TYPE.SOCCER_TEAM_JOINING) {
                    this.setIsShowScoutPopup()
                } else {
                    // refer_idx가 있으면 훈련영상
                    if (this.soccerhow.refer_idx) {
                        this.setIsShowFeedbackPoup()
                    // 없으면 그라운드 게시물
                    } else {
                        this.setIsShowGroundPopup()
                    }
                }
            } else {
                this.$GlobalStore.closeLastModal()
            }
        },
        setIsShowFeedbackPoup() {
            const popupInfo = {
                closeDateTitle: 'FEEDBACK_CLOSE_DATE',
                popupTitle: '이 선수에게<br>피드백을 주시는건 어떠신가요?',
                btnName: '훈련 피드백 주기',
                beforeClosePopupFunc: () => {
                    const soccerhowInfo = {
                        soccerhow: this.soccerhow,
                        insert_date: this.soccerhow.insert_date,
                        from_member: {
                            nic_name: this.soccerhow.nic_name,
                            position: this.soccerhow.position,
                            place: {
                                name: this.soccerhow.place_name
                            },
                            
                        },
                    }
                    this.$GlobalStore.addModal('SendTrainingFeedback', { messageInfo: soccerhowInfo, completeAction: this.completeActionFeedbackPopup})
                }
            }
            this.setIsShowBeforeClosePopup(popupInfo)
        },
        async completeActionFeedbackPopup(is_accepted, messageIdx, feedback_message) {
            const formData = new FormData()
            formData.append('to_member_idx', this.$GlobalStore.loginInfo().idx)
            formData.append('from_member_idx', this.memberInfo.idx)
            formData.append('refer_idx', this.soccerhow.idx)

            const res = await this.$Axios.post('/api/direct_message/send/training_video', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.sendTrainingFeedback(is_accepted, res.data.message_idx, feedback_message)
            }
        },
        async sendTrainingFeedback(is_accepted, messageIdx, feedback_message){
            const formData = new FormData()
            formData.append('is_accepted', is_accepted)
            formData.append('direct_message_idx', messageIdx)
            formData.append('feedback_message', feedback_message)

            const res = await this.$Axios.post('/api/direct_message/change/status', formData);
            if(res.data.code === ResponseCode.SUCCESS){
                if(is_accepted){
                    const chatIdx = res.data.chat_idx;
                    this.$GlobalStore.closeLastModal()
                    await this.$Axios.showChattingBySoccerJoinIdx(chatIdx);
                }
            } else if(res.data.code === ResponseCode.FAIL){
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        setIsShowScoutPopup() {
            const popupInfo = {
                closeDateTitle: 'REQUEST_CLOSE_DATE',
                popupTitle: '이 선수는 어떠셨나요?<br>바로 스카우트 제의를 보내볼까요?',
                btnName: '스카우트 제의 보내기',
                beforeClosePopupFunc: () => {
                    this.showDirectMessage()
                    this.$Util.sendEventClick('사커하우_요청서_다이렉트메시지', true)
                }
            }
            this.setIsShowBeforeClosePopup(popupInfo)
        },
        setIsShowGroundPopup() {
            const popupInfo = {
                closeDateTitle: 'GROUND_CLOSE_DATE',
                popupTitle: '이 선수에게<br>조언을 남겨볼까요?',
                btnName: '댓글 달기',
                beforeClosePopupFunc: () => {
                    this.closeBeforeClosePopup()
                    this.$refs.chatInput.focus()
                }
            }
            this.setIsShowBeforeClosePopup(popupInfo)
        },
        setIsShowBeforeClosePopup(popupInfo) {
            const COMMON_CLOSE_DATE = localStorage.getItem(popupInfo.closeDateTitle)
            const today = moment().format('YYYY-MM-DD');
            const isPassOneDay = today === COMMON_CLOSE_DATE ? true : false

            if (!isPassOneDay) {
                this.popupTitle = popupInfo.popupTitle
                this.btnName = popupInfo.btnName
                this.beforeClosePopupFunc = popupInfo.beforeClosePopupFunc
                this.isShowBeforeClosePopup = true
                localStorage.setItem(popupInfo.closeDateTitle, today)
            } else {
                this.$GlobalStore.closeLastModal()
            }
        },
        setReplyIdx(replyInfo) {
            if (!this.isActiveCommentReply) {
                this.cur_reply_soccerhow_idx = replyInfo.idx
                this.inputNicName = replyInfo.nic_name
                this.isActiveCommentReply = true
                this.$refs.chatInput.focus()
            } else {
                this.cur_reply_soccerhow_idx = -1
                this.inputNicName = null
                this.isActiveCommentReply = false
            }
        },
        detectResize() {
            if (window.visualViewport.offsetTop === 0) {
                if (this.$cookies.get('device') === 'ios') {
                    this.$GlobalStore.unsetLastModalFixedInIOS(this.cur_modal_length - 1);
                }
            } else {
                if (this.$cookies.get('device') === 'ios') {
                    this.$GlobalStore.setLastModalFixedInIOS(window.visualViewport.offsetTop, window.visualViewport.height);
                }
            }
        },
        goReplyTop() {
            this.$nextTick(() => {
                const target = this.$refs.test;
                if (target) {
                    target.scrollIntoView({ behavior: "smooth", block: "nearest" });
                }
            });
        },
        refreshDetail() {
            this.directMessage = []
            this.pushMessage = []
            this.feedbackList = []
            this.isReportingExist = false
            this.replies = []
            this.soccerhow = {}
            this.memberInfo = {}
            this.youtubeLink = ''
            this.contents = ''
            this.getSoccerhowDetail()
            this.getReplyList()
            this.getFeedbackList()
        },
        async showPesonalChat() {
            this.isShowBookmarkPopupMessage = false;
            await this.$Axios.showChattingBySoccerJoinIdx(this.chatIdx);
        },
        confirmRejectDirectMessage() {
            if (!this.isExpert) {
                this.rejectOrAcceptDierectMessage(false, this.directMessage[this.curIndex].idx)
            } else {
                this.rejectOrAcceptDierectMessage(false, this.directRequestList[this.curIndex].idx)
            }
        },
        async rejectOrAcceptDierectMessage(is_accepted, messageIdx) {
            const formData = new FormData()
            formData.append('is_accepted', is_accepted)
            formData.append('direct_message_idx', messageIdx)

            const res = await this.$Axios.post('/api/direct_message/change/status', formData)

            let prev_direct_message;

            if (!this.isExpert) {
                prev_direct_message = window.copyObject(this.directMessage[this.curIndex]);
                this.$delete(this.directMessage, this.curIndex)
            } else {
                prev_direct_message = window.copyObject(this.directRequestList[this.curIndex]);
                this.$delete(this.directRequestList, this.curIndex)
            }

            if (res.data.code === 0) {

                const parameters = {};
                parameters.target_member_idx = prev_direct_message.from_member.idx;
                const res = await this.$Axios.get('/api/chat/check/coach_chat/exist', { params: parameters });
                if (res.data.code === ResponseCode.SUCCESS) {
                    if (res.data.chat_idx) {
                        await this.$Axios.showChattingBySoccerJoinIdx(res.data.chat_idx)
                        this.closeModal()
                        return;
                    }
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                    return;
                }

                if (!is_accepted) {
                    this.closeModal()
                } else {
                    this.chatIdx = res.data.chat_idx
                    this.isShowBookmarkPopupMessage = true
                    if (prev_direct_message) {
                        if (prev_direct_message.from_member.is_coach == '1') {
                            this.coach_member = prev_direct_message.from_member;
                            this.user_member = prev_direct_message.to_member;
                        } else if (prev_direct_message.to_member.is_coach == '1') {
                            this.coach_member = prev_direct_message.to_member;
                            this.user_member = prev_direct_message.from_member;
                        }
                    }
                }
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
                this.closeModal()
            }
        },
        openChatting() {
            this.isShowModal = false;
            if (!this.isExpert) {
                this.rejectOrAcceptDierectMessage(true, this.directMessage[this.curIndex].idx)
            } else {
                this.rejectOrAcceptDierectMessage(true, this.directRequestList[this.curIndex].idx)
            }
        },
        closeModal() {
            this.isShowModal = false
            this.detailInfo = {}
        },
        async setModal(type, i, messageDetail) {
            this.curModalType = type
            if (this.curModalType === MODAL_TYPE.ACCEPT) {
                this.modalHeight = 322
            } else {
                this.modalHeight = 232
            }
            this.curIndex = i
            this.isShowModal = true
            this.selectMessage = messageDetail
        },
        joinMemberTalkConfirm(detailInfo) {
            this.detailInfo = detailInfo
            if (this.detailInfo.is_me_joined) {
                this.showChat(this.detailInfo)
                return
            }
            this.curModalType = MODAL_TYPE.JOIN
            this.modalHeight = 232
            this.isShowModal = true
        },
        async deleteSoccerhow() {
            if (confirm('삭제 하시겠습니까?')) {
                const res = await this.$Axios.post('/api/soccerhow/delete', { deleteList: [this.soccerhowIdx] });

                if (res.data.code === 0) {
                    this.completeAction()
                    this.$GlobalStore.closeLastModal()
                }
            }
        },
        closeRequestJoinForm(isSave = false) {
            if (isSave) {
                this.getSoccerhowDetail()
                this.completeAction()
            }
            this.isShowMakeRequestJoinForm = false
        },
        setMakeRequestJoinForm() {
            this.isShowMakeRequestJoinForm = true
        },
        async goToTop() {
            const formData = new FormData()
            formData.append('soccerhow_idx', this.soccerhowIdx)

            const res = await this.$Axios.post('/api/soccerhow/last_top/update', formData)

            if (res.data.code == 0) {
                this.$GlobalStore.showAlert('요청서를 끌어올렸습니다.')
                this.completeAction()
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        async getSoccerhowDetail() {
            const parameters = {}
            parameters.soccerhow_idx = this.soccerhowIdx;
            parameters.is_from_list = true;
            parameters.is_visit = true;

            const res = await this.$Axios.get('/api/soccerhow/detail', { params: parameters })
            if (res.data.code === 1) {
                this.$GlobalStore.showAlert('삭제된 글 입니다.');
                this.$GlobalStore.closeLastModal();
                return;
            }

            const directMessage = res.data.direct_message || []
            const pushMessage = res.data.push_messages || []
            const isReportingExist = res.data.is_reporting_exist
            const soccerhow = res.data.soccerhow || {}
            const memberInfo = res.data.member

            if (!this.is_loaded) {
                if ([SOCCER_HOW_TYPE.SINGLE_TRAINING, SOCCER_HOW_TYPE.GROUP_TRAINING].indexOf(soccerhow.type) > -1) {
                    this.curType = BTN_TYPE.REPLY;
                } else if ([SOCCER_HOW_TYPE.SC_JOB, SOCCER_HOW_TYPE.SC_JOIN, SOCCER_HOW_TYPE.SC_COUNSEL].indexOf(soccerhow.type) > -1) {
                    if (this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().idx == soccerhow.writer_idx) {
                        this.curType = BTN_TYPE.REQUEST;
                    } else {
                        this.curType = BTN_TYPE.ALARM;
                    }
                }
            }

            this.is_loaded = true;

            this.is_me_member_liked = res.data.is_me_member_liked;
            this.directMessage = directMessage
            this.pushMessage = pushMessage
            this.isReportingExist = isReportingExist
            this.soccerhow = soccerhow
            this.memberInfo = memberInfo
            if (this.$Util.getYoutubeLinkArr(this.soccerhow.contents)) {
                const youtubeLink = this.$Util.getYoutubeLinkArr(this.soccerhow.contents)[0]
                const contents = this.$Util.removeYoutubeLink(this.soccerhow.contents)
                this.youtubeLink = youtubeLink
                this.contents = contents
            }
        },
        backToMainReply() {
            // setTimeout(() => {
            //     if (this.cur_reply_soccerhow_idx != -1) this.replyModeReset();
            // }, 100)
        },
        calcContentsLength(e) {
            this.contentsLength = e.target.value.length
        },
        async submitReply() {
            if (this.replyContents === '') {
                this.$GlobalStore.showAlert('내용을 입력하세요.')
                return
            }
            if (this.isPopular) {
                this.$Util.sendEventClick('인기글_게시물상세_댓글달기', true)
            } else if (this.isRealTime) {
                this.$Util.sendEventClick('사커하우_댓글달기', true)
            }
            const formData = new FormData()

            formData.append('contents', this.replyContents);
            formData.append('parentIdx', this.cur_reply_soccerhow_idx !== -1 ? this.cur_reply_soccerhow_idx : this.soccerhow.idx);
            formData.append('type', SOCCER_HOW_TYPE.REPLY);
            formData.append('reply_to_member_idx', this.memberInfo.idx)
            const res = await this.$Axios.post('/api/soccerhow/save', formData);

            if (res.data.code === ResponseCode.SUCCESS) {
                this.getSoccerhowDetail()
                this.getReplyList()
                if (this.cur_reply_soccerhow_idx === -1) {
                    this.goReplyTop()
                }
                this.replyContents = ''
                this.inputNicName = null
                this.cur_reply_soccerhow_idx = -1
                this.contentsLength = 0
                this.$refs.chatInput.style.height = '40px'
                this.isActiveCommentReply = false
                // let isCompleteReplyMission = res.data.today_reply_count >= 5 ? true : false
                // if (res.data.today_reply_count <= 5) {
                //     this.$GlobalStore.addModal('CompleteMissonPopup', { 
                //         isModalBackTransparent: true, 
                //         transitionName: '', 
                //         mission_type: MISSION_TYPE.REPLY, 
                //         isCompleteReplyMission: isCompleteReplyMission,
                //         replyMissionCount: res.data.today_reply_count
                //     })
                // }
            }
        },
        async getReplyList() {
            const parameters = {}
            parameters.parentIdx = this.soccerhowIdx
            parameters.replyDeep = 1
            parameters.parent_type = 'reply'
            parameters.child_type = 'reply'

            const res = await this.$Axios.get('/api/soccerhow/replies', { params: parameters })
            this.replies = res.data.replies || []
        },
        async getFeedbackList() {
            const parameters = {}
            parameters.parentIdx = this.soccerhowIdx
            parameters.type = SOCCER_HOW_TYPE.FEEDBACK
            const res = await this.$Axios.get('/api/soccerhow/feedbacks', { params: parameters });
            if (res.data.code === ResponseCode.SUCCESS) {
                this.feedbackList = res.data.feedback_list || []
            }
        },
        checkLogin() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
        },
        submit() {

        },
        closeBookmarkPopup() {
            this.isShowBookmarkPopup = false
            this.isShowBookmarkPopupMessage = false
            this.isShowBookmarkPopupReport = false
        },
        async showDirectMessage() {
            this.isShowScoutPopup = false
            await this.$Util.showDirectMessageSenderForm({ memberInfo: this.memberInfo, soccerhowIdx: this.soccerhow.idx, main_type: this.main_type, soccerhow: this.soccerhow });
        },
        setBtnType(type) {
            this.curType = type
        },
        setIsShowPossessionDm() {
            this.isShowPossessionDm = true
        },
        closePossessionDm() {
            this.isShowPossessionDm = false
        },
        async sendLike() {
            const formData = new FormData()
            formData.append('target_idx', this.soccerhow.writer_idx);
            formData.append('from', this.isFromChatRuqest ? 'request' : 'training')
            formData.append('refer_idx', this.soccerhow.idx);
            formData.append('is_from_detail', true);

            const res = await this.$Axios.post('/api/like/soccerhow/interest/save', formData)
            if (res.data.code === ResponseCode.SUCCESS) {
                this.is_me_member_liked = true;
                this.getSoccerhowDetail();
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async cancelMemberLike() {
            const parameters = {};
            parameters.soccerhow_idx = this.soccerhow.idx;
            const res = await this.$Axios.post('/api/like/soccerhow/interest/delete', parameters)
            if (res.data.code === ResponseCode.SUCCESS) {
                this.is_me_member_liked = false;
                this.getSoccerhowDetail();
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        showMyReport() {
            this.$GlobalStore.addModal('RequestReportDetail', { soccerhowIdx: this.soccerhowIdx })
        },
        report() {
            this.$Util.sendEventClick('사커하우_게시물신고')

            let report_refer_type = '';

            if ([SOCCER_HOW_TYPE.SINGLE_TRAINING, SOCCER_HOW_TYPE.GROUP_TRAINING].indexOf(this.soccerhow.type) > -1) {
                report_refer_type = REPORT_TYPE_IDX.SOCCERHOW_TRAINING;
            } else if ([SOCCER_HOW_TYPE.SC_JOB, SOCCER_HOW_TYPE.SC_JOIN, SOCCER_HOW_TYPE.SC_COUNSEL].indexOf(this.soccerhow.type) > -1) {
                report_refer_type = REPORT_TYPE_IDX.SOCCERHOW_REQUEST;
            }

            this.$GlobalStore.addModal('ReportPopup',
                {
                    target_member_idx: this.memberInfo.idx,
                    target_member_type: this.soccerhow.writer_type,
                    refer_type: report_refer_type,
                    refer_idx: this.soccerhow.idx,
                    report_title: this.soccerhow.title,
                    report_contents: this.soccerhow.contents
                }
            );
        },
        shareTrainingRequest() {
            const message = '';
            let url = ''

            if (process.env.NODE_ENV === 'development') {
                url = 'http://192.168.0.203:8080';
            } else {
                if (process.env.VUE_APP_IS_TEST_SERVER !== undefined) {
                    url = 'https://obyungear-user-test.ubiplus.co.kr';
                } else {
                    url = 'https://app.soccerhow.com';
                }
            }

            url += '/training?type=' + (this.main_type === MAIN_TYPE.SOCCER_LEARN ? 'learn' : 'request') + '&idx=' + this.soccerhow.idx;
            // console.log(url);
            const device = this.$cookies.get('device');
            if (device === 'android') {
                const text = (message === "" ? "" : message + "\n") + url;
                window.Android.shareUrl(text);
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'shareUrl', text: message, url: url });
            }
        },
        setIsShowPopMenu() {
            this.isShowPopMenu = true
            const labelAndAction = []

            if (this.isMeCreator) {
                labelAndAction.push(
                    {
                        label: '수정하기', action: () => {
                            this.isShowMakeRequestJoinForm = true;
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '삭제하기', action: () => {
                            this.deleteSoccerhow();
                            this.isShowPopMenu = false;
                        },
                    }
                );
                if (this.main_type === MAIN_TYPE.SOCCER_TEAM_JOINING) {
                    labelAndAction.push({
                        label: '끌어올리기', action: () => {
                            this.goToTop();
                            this.isShowPopMenu = false;
                        },
                    });
                }

                labelAndAction.push({
                    label: '공유하기', action: () => {
                        this.shareTrainingRequest();
                        this.isShowPopMenu = false;
                    },
                });
            } else {
                labelAndAction.push(
                    {
                        label: '프로필 보기', action: () => {
                            this.$Util.showProfile(this.soccerhow.writer_idx, this.soccerhow.writer_type, '', 0);
                            this.isShowPopMenu = false
                        },
                    }
                )
                labelAndAction.push(
                    {
                        label: '신고하기', action: () => {
                            this.isShowBookmarkPopupReport = true
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '공유하기', action: () => {
                            this.shareTrainingRequest();
                            this.isShowPopMenu = false
                        },
                    },
                )
            }

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        }
    }
}
</script>

<style scoped>
.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background: #bbb;
    opacity: 1;
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: var(--color-main);
    border-radius: 8px;
}

.feedback_write_btn {
    background-color: var(--color-main);
    border-radius: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 11px 0;
    line-height: 24px;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    width: 169px;
    margin: 0 auto;
    margin-top: 20px;
}
</style>